import { render, staticRenderFns } from "./BackgroundDeleteModal.vue?vue&type=template&id=219f32d4&"
import script from "./BackgroundDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./BackgroundDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports